export default "__VITE_ASSET__Dio8dWQx__"